<template>
  <div v-if="!loading" class="sp-mode">
    <div class="container" id="header">
      <a id="logo" href="https://www.westjr.co.jp/" target="_blank"><img src="../../assets/images/jr_logo_title.svg" width="200" alt="JR西日本旅客鉄道株式会社"></a>
      <a class="text-center pdf-btn" target="_blank" :href="baseUrl + this.pdfPath" @click="onPDF()">PDF出力</a>
    </div>
    <div class="contents container">
      <div id="contents">
        <h1>遅延証明書</h1>
        <div class="line-info">
          <span id="line-mark" v-if="line">
            <i v-if="line.line_color_1" :style="{ border: 'solid 4px ' + line.line_color_1, 'background-color': line.line_color_1 }"></i><i v-if="line.line_color_2" :style="{ border: 'solid 4px ' + line.line_color_2, 'background-color': line.line_color_2 }"></i><i v-if="line.line_color_3" :style="{ border: 'solid 4px ' + line.line_color_3, 'background-color': line.line_color_3 }"></i>
          </span>
          <h4 v-if="line">
            {{ line.line_name }}<template v-if="line.section_name">({{ line.section_name }})</template><br/>
            <span v-if="isToday">{{ targetDate | jpYYYYMMDDdd }}</span>
            <span v-else-if="isHistory">{{ targetDate | jpYYYYMMDDdd }}</span>
          </h4>
        </div>
        <p v-if="line && timeZone">{{ line.line_name }}<template v-if="line.section_name">({{ line.section_name }})</template>の列車が{{ timeZone.display_name }}の間、最大で以下の通り遅れたことを証明します。<br/>ご迷惑をおかけし、誠に申し訳ございませんでした。</p>
        <div id="delayTime" class="text-center">
          <div id="out">
            <div id="inner">
              <div class="delay-number">{{ delayCertificateNum }}<span class="line-timezone-delay-data-text">{{ delayCertificateText }}</span></div>
            </div>
          </div>
        </div>
        <ul>
          <li>本証明書は、その路線で発生した最大の遅延時分を証明するものであり、個々の列車の遅延時分を証明するものではありません。また、お客様がご乗車されたことを証明するものではありません。</li>
          <li>本証明書は、JR線の遅延のみを証明するものであり、遅延によりお客様に生じた損害等を賠償することを証明するものではありません。</li>
          <li>本証明書は、JR線の一部の駅で発行している遅延証明書と遅延時分が異なることがあります。</li>
          <li>本証明書を無断で転載、複写すること、また、体裁を変更するなどしてホームページ等で公開することを固く禁じます。</li>
        </ul>
        <p id="company-name">
          {{ today | jpYYYYMMDDdd}}
          <br>
          <img style="width: 9.8rem;" src="../../assets/images/jr-name-logo.svg"/>
        </p>
      </div>
    </div>
    <div class="container" id="comment">※ 「PDF出力」ボタンをタップして、PDFファイルをダウンロードしてください。</div>
    <div id="footer">
      Copyright © WEST JAPAN RAILWAY COMPANY all rights reserved. このサイトに掲載されている情報はJR西日本が提供しております。
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from 'configs'
var moment = require('moment')
export default {
  name: 'SpDelayCertificate',
  data () {
    const targetDate = this.$route.params.targetDate
    const today = moment()
    const isToday = this.$route.params.today === 'today'
    const isHistory = this.$route.params.today === 'history'
    const areaId = parseInt(this.$route.params.areaId, 10)
    const lineId = parseInt(this.$route.params.lineId, 10)
    const timeZoneId = parseInt(this.$route.params.timeZoneId, 10)
    const baseUrl = config.api.base
    let pdfPath
    if (isToday) {
      pdfPath = '/today/pdf/' + areaId + '/' + lineId + '/' + timeZoneId
    } else {
      pdfPath = '/history/pdf/' + areaId + '/' + lineId + '/' + targetDate + '/' + timeZoneId
    }
    return {
      today,
      isToday,
      isHistory,
      pdfPath,
      areaId,
      lineId,
      timeZoneId,
      targetDate,
      baseUrl,
      area: undefined,
      line: undefined,
      timeZone: undefined,
      delayCertificate: '',
      delayCertificateNum: '',
      delayCertificateText: ''
    }
  },
  methods: {
    isNum (num) {
      return num !== undefined && /^\d+$/.test(num) === true
    },
    onPDF () {
      this.$gtag.event('click', {
        'event_category': 'pdf',
        'event_label': this.pdfPath,
        'value': 1
      })
    },
    init () {
      if (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init') {
        return
      }
      this.area = this.areas.find(area => area.area_id === this.areaId)
      if (this.area === undefined) {
        this.$router.push({name: 'SpPageNotFound'})
        return
      }
      this.line = this.area.lines.find(line => line.line_id === this.lineId)
      if (this.line === undefined) {
        this.$router.push({name: 'SpPageNotFound'})
        return
      }
      this.timeZone = this.timeZones.find(timeZone => timeZone.time_zone_id === this.timeZoneId)
      if (this.timeZone === undefined) {
        this.$router.push({name: 'SpPageNotFound'})
        return
      }
      if (this.isToday) {
        this.$store.commit('delaycertificatetoday/setStatus', '')
        this.$store.dispatch('delaycertificatetoday/all', [this.areas, this.timeZones])
        const unwatchDelayCertificateToday = this.$store.watch(
          (state) => state.delaycertificatetoday.status,
          (value) => {
            if (value === 'init') {
              unwatchDelayCertificateToday()
              try {
                this.targetDate = moment(this.todayDelays.created_at).hour() < 3 ? moment(this.todayDelays.created_at).subtract(1, 'days') : this.todayDelays.created_at
                const lines = this.todayDelays.areas.find((area) => area.area_id === this.areaId).lines
                const line = lines.find((line) => line.line_id === this.lineId)
                const timeZonesDelay = line.delay_certificates
                const cert = timeZonesDelay.find((item) => item.time_zone_id === this.timeZoneId)
                if (cert.delay_certificate_item_type === 'DELAY_CERTIFICATE') {
                  // 遅延証明書表示
                  this.delayCertificate = cert.delay_certificate
                  this.delayCertificateNum = this.delayCertificate.replace(/[^0-9]/g, '')
                  this.delayCertificateText = this.delayCertificate.replace(/[0-9]/g, '')
                  this.$store.commit('loading/setStatus', false)
                  return
                }
              } catch (err) {
              }
              this.$router.push({name: 'SpPageNotFound'})
            }
          }
        )
      } else if (this.isHistory) {
        this.$store.commit('history/setStatus', '')
        this.$store.dispatch('history/all', [this.lineId, this.timeZones])
        const unwatchHistory = this.$store.watch(
          (state) => state.history.status,
          (value) => {
            if (value === 'init') {
              unwatchHistory()
              try {
                const dateDelay = this.historys.find(item => item.date === this.targetDate)
                const cert = dateDelay.data.find((item) => item.time_zone_id === this.timeZoneId)
                if (cert.delay_certificate_item_type === 'DELAY_CERTIFICATE') {
                  // 遅延証明書表示
                  this.delayCertificate = cert.delay_certificate
                  this.delayCertificateNum = this.delayCertificate.replace(/[^0-9]/g, '')
                  this.delayCertificateText = this.delayCertificate.replace(/[0-9]/g, '')
                  this.$store.commit('loading/setStatus', false)
                  return
                }
              } catch (err) {
              }
              this.$router.push({name: 'SpPageNotFound'})
            }
          }
        )
      } else {
        this.$router.push({path: '/404'})
      }
    }
  },
  created () {
    if (!this.isNum(this.$route.params.areaId) ||
      !this.isNum(this.$route.params.lineId) ||
      !this.isNum(this.$route.params.timeZoneId)) {
      this.$router.push({name: 'SpPageNotFound'})
      return
    }
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init()
        }
      }
    )
    const unwatchTimeZone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimeZone()
          this.init()
        }
      }
    )
  },
  computed: {
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaStatus: state => state.status
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status
    }),
    ...mapState('delaycertificatetoday', {
      todayDelays: state => state.todayDelays,
      todayStatus: state => state.status
    }),
    ...mapState('history', {
      historys: state => state.historys,
      historyStatus: state => state.status
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.line-timezone-delay-data-text {
  font-size: 1.5rem;
  margin-left: 0.3rem;
}
#header {
  padding-bottom: 8px;
  padding-top: 8px;
  border-bottom: 1px solid #ccc;
  display: flex;
  #logo {
    flex: 1;
    align-items: center;
    display: flex;
  }
  .pdf-btn {
    background-color: white;
    color: #1a1a1a;
    border-radius: 0;
    max-width: 4.75rem;
    min-width: 4rem;
    line-height: 2rem;
    border: solid 1px #ccc;
    flex: 1;
    font-size: 0.875rem;
    text-decoration: none;
    box-shadow: 0.05rem 0.05rem 0.05rem rgba(0,0,0,0.4);
  }
}
#footer {
  background-color: $footer-dark-back;
  padding: 2.06rem 1.25rem;
  color: white;
  padding-top: 30px;
  font-size: 0.75rem;
  margin-top: 1.875rem;
}
.contents{
  padding-top: 1.875rem;
  padding-bottom: 1.06rem;
  #contents{
    padding-left: 0.94rem;
    padding-right: 0.94rem;
    padding-bottom: 1.44rem;
    border: solid 2px #3070b3;
    h1 {
      line-height: 2rem;
      font-size: 1.5rem;
      font-weight: 600;
      padding: 0.9375rem;
      border-bottom: dotted 1px;
      margin-bottom: 0;
    }
    .line-info {
      margin: 1.8125rem 0;
      #line-mark {
        float: left;
        i {
          width: 9px;
          border-radius: 4px;
          margin-right: 1px;
          height: 24px;
          display: inline-block;
        }
      }
      h4 {
        font-size: 1.25rem;
        line-height: 1.69rem;
        font-weight: 600;
        span {
          font-size: 1rem;
          line-height: 1.31rem;
        }
      }
    }
    p {
      font-size: 1rem;
      margin-bottom: 0;
      margin-left: 0.6rem;
    }
    ul {
      list-style: none;
      padding-inline-start: 1.2rem;
      li {
        font-size: 1rem;
        line-height: 1.41rem;
      }
      li::before {
        content: "\2022";
        color: $primary;
        font-weight: bold;
        display: inline-block;
        width: 0.75rem;
        margin-left: -0.75rem;
      }
    }
  }
  #delayTime {
    padding: 2.07rem 2.06rem;
    font-weight: 600;
    #out {
      border: solid 4px #e02d2d;
      padding: 3px;
      color: #e02d2d;
      #inner {
        .delay-number {
          border: solid 2px #e02d2d;
          line-height: 3rem;
          font-size: 2.25rem;
        }
      }
    }
  }
  #company-name {
    text-align: right;
    margin-top: 0.6rem;
    margin-left: 0 !important;
    padding-top: 1rem;
    border-top: dotted 1px #3070b3;
    font-size: 1rem;
    line-height: 1.44rem;
  }
  #comment {
    font-size: 0.875rem;
    line-height: 1.1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/sp/SpDelayCertificate.vue